module.exports = __webpack_public_path__ + "static/img/help_image.8e601fc1.png";